import { IconOrder } from '@components/Icons/Icons';
import { subNav } from '@components/Navbar/SubNav';

export const navId = 'subNavContentOrder';
const links = [
  { title: 'Numbers', href: '/order/numbers' },
  { title: 'Dedicated Channel', href: '/order/dedicated-channels' },
  {
    title: 'Shared Channel',
    href: '/order/shared-channels',
    onlyCapacity: true,
  },
  { title: 'PSTN Upgrade', href: '/order/pstn-upgrade' },
  {
    title: 'Open Orders',
    href: '/order/open',
    activePaths: ['/order/open/:uuid/details'],
  },
  {
    title: 'Order History',
    href: '/order/history',
    activePaths: ['/order/history/:uuid/details'],
  },
  {
    title: 'Incomplete orders',
    href: '/order/incomplete',
    activePaths: ['/order/incomplete/:uuid/details'],
  },
];
const orderSubNav = () =>
  subNav({ id: navId, title: 'Order', href: '/order', icon: IconOrder, links });
export default orderSubNav;
